import { render } from "./403.vue?vue&type=template&id=4e369a8b&scoped=true"
const script = {}

import "./403.vue?vue&type=style&index=0&id=4e369a8b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e369a8b"]])

export default __exports__